export default __webpack_public_path__ + "static/media/hero-bg.334b2229.png";